import _omit from 'lodash.omit';
import { INPUT } from '../../../common/styles/Input';

const OMITTED_PROPS = [
'label',
'prefix',
'suffixIcon',
'clearButton',
'errorMessage',
'className',
'multiline',
'defaultValue',
'valid',
'validate',
'inputProps',
'autoGrow',
'requiredField',
'inputProps',
'labelProps'];













/**
 * Builds a props object to be passed to the input element
 *
 * @param {Props} props
 *
 * @return {Object}
 */
export default function buildInputProps({
  calculatedSuffixIcon,
  valid,
  allProps,
  onFocus,
  onBlur,
  onChange,
  type,
  autoGrow
}) {
  const { prefix, disabled } = allProps;
  const hasPrefix = Boolean(prefix);
  const hasSuffix = Boolean(calculatedSuffixIcon);

  return {
    className: INPUT({
      valid,
      disabled,
      hasPrefix,
      hasSuffix,
      type,
      autoGrow
    }),
    ..._omit(allProps, OMITTED_PROPS),
    onFocus,
    onBlur,
    onChange
  };
}